import { useEffect, useState } from 'react';
import { readAccessToken } from '@/utils/auth-token-store';
const useAuthStatus = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(() => !!readAccessToken());
    useEffect(() => {
        const checkLogin = () => {
            const token = readAccessToken();
            setIsLoggedIn(!!token);
        };
        checkLogin();
        // Optional: listen for storage changes (multi-tab login/logout sync)
        window.addEventListener('storage', checkLogin);
        window.addEventListener('authChange', checkLogin);
        return () => {
            window.removeEventListener('storage', checkLogin);
            window.removeEventListener('authChange', checkLogin);
        };
    }, []);
    return isLoggedIn;
};
export default useAuthStatus;
